/**
 * 360 Spin Viewer - Fullscreen functionality for Sirv 360 viewers
 */
(function() {
  'use strict';

  function initExpandButtons() {
    // Use event delegation to handle all expand buttons
    document.addEventListener('click', function(event) {
      var expandBtn = event.target.closest('.sirv-spin-expand-btn');
      if (!expandBtn) return;

      event.preventDefault();

      var container = expandBtn.closest('.sirv-spin-container');
      if (!container) return;

      var sirvElement = container.querySelector('.Sirv');
      if (!sirvElement) return;

      // Try Sirv's fullscreen API first
      if (typeof Sirv !== 'undefined' && Sirv.getInstance) {
        var viewer = Sirv.getInstance(sirvElement);
        if (viewer && typeof viewer.fullscreen === 'function') {
          viewer.fullscreen();
          return;
        }
      }

      // Fallback to native fullscreen
      var elementToFullscreen = sirvElement.querySelector('.smv') || container;

      if (elementToFullscreen.requestFullscreen) {
        elementToFullscreen.requestFullscreen();
      } else if (elementToFullscreen.webkitRequestFullscreen) {
        elementToFullscreen.webkitRequestFullscreen();
      } else if (elementToFullscreen.msRequestFullscreen) {
        elementToFullscreen.msRequestFullscreen();
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExpandButtons);
  } else {
    initExpandButtons();
  }
})();
